import $ from "jquery";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import avatar from "../../../../assets/appImages/user.png";
import Factures from "../../../../assets/icons/facture.png";
import TvaCollecte from "../../../../assets/icons/tva-collecte.png";
import TvaEmise from "../../../../assets/icons/tva-emise.png";
import Users from "../../../../assets/icons/users.png";
import {
  getDateFromString,
  getFactureDate,
} from "../../../../redux/slice/invoiceSlice";
import { useAppSelector } from "../../../../redux/store";
import {
  Categorie,
  FactureEmise,
  InvoiceData,
  ModelDevis,
  UserInfos,
} from "../../../../redux/types";
import ExcelExport from "../../../../utils/Excelexport";
import {
  getFacturesByComptableAPi,
  getInvoicesByComptableAPi,
} from "../../../../utils/api/rest-api";
import {
  getExportData,
  getExportDataFacture,
  getModelsByUser,
} from "../../../../utils/api/user.api";
import {
  formatNumber,
  useActiveTab,
  useUserCategories,
} from "../../../../utils/utils";
import { computeDashboardTotals } from "../../../../utils/dashboard-totals";
import { splitInvoicesByType } from "../../../../utils/invoice-type";
import ListeFactureComtabiliteTable from "../../../tables/comptabilite/ListeFactureComtabiliteTable/ListeFactureComtabiliteTable";
import ListeFactureEmiseComtabiliteTable from "../../../tables/comptabilite/ListeFactureComtabiliteTable/ListeFactureEmiseComtabiliteTable";
import { CardSkeleton } from "../../Admin/Dashboard/DashboardAdmin";
import DonutChart from "./DonutChart";
import "./style.css";

const tabs = [
  "Factures dépenses",
  "Factures émises",
  "Factures émises scannées",
];
const DetailUserComptabilite = () => {
  const [isLoading, setIsLoading] = React.useState(true);
  const { active, handleActiveTab } = useActiveTab();
  const [invoices, setInvoices] = useState<InvoiceData[]>([]);
  const [factures, setFactures] = useState<FactureEmise[]>([]);
  // Entités légales de l'utilisateur : elles alimentent le filtre « Entité
  // légale » du tableau des factures émises. L'API comptable ne renvoie que le
  // modelId, nom du champ en base.
  const [models, setModels] = useState<ModelDevis[]>([]);
  // Les documents scannés arrivent mélangés : les dépenses d'un côté, les
  // factures émises scannées depuis l'application de l'autre.
  const { depenses, emisesScannees } = useMemo(
    () => splitInvoicesByType(invoices),
    [invoices]
  );
  const categories = useAppSelector((s) => s.categories);
  const [params] = useSearchParams();
  const invoiceId = params.get("invoiceId");
  const user = useAppSelector((s) => s.auth.userInfos);
  const [_, setShowed] = useState(false);
  const [dashboard, setDashboard] = React.useState({
    total_facture_depenses: 0,
    total_tve_recuperable: 0,
    total_facture_emises: 0,
    total_tva_emises: 0,
  });
  React.useEffect(() => {
    // Calcul partagé avec l'espace admin (utils/dashboard-totals.ts). La
    // version locale additionnait les montants sans les convertir : une seule
    // valeur stockée en chaîne suffisait à concaténer tout le total.
    const t = computeDashboardTotals(invoices, factures);
    setDashboard({
      total_facture_depenses: t.total_facture_depense,
      total_tve_recuperable: t.total_tva_recuperable,
      total_facture_emises: t.total_facture_emise,
      total_tva_emises: t.total_tva_emise,
    });
  }, [invoices, factures]);
  const navigate = useNavigate();
  const location: any = useLocation();
  const { state } = location as { state: UserInfos };

  const getInvoices = useCallback(async () => {
    if (user && state?.uid) {
      const invoices = await getInvoicesByComptableAPi(user.email);
      const factures = await getFacturesByComptableAPi(user.email);
      setInvoices(() => {
        const newState = invoices.filter((i) => i.userId === state.uid);
        return newState.sort((a, b) => getFactureDate(b) - getFactureDate(a));
      });
      setFactures(() => {
        const newState = factures.filter(
          (i) => i.statut !== "En cours" && i.userId === state.uid
        );
        return newState.sort((a, b) => b.created_at - a.created_at);
      });
      setIsLoading(false);
    }
  }, [state.uid]);

  useEffect(() => {
    setIsLoading(true);
    getInvoices();
  }, [getInvoices]);

  // Le filtre « Entité légale » n'est qu'un confort : s'il échoue, la colonne
  // disparaît et le tableau reste utilisable.
  useEffect(() => {
    if (!state?.uid) return;
    let abandoned = false;
    getModelsByUser(state.uid)
      .then((data) => {
        if (!abandoned) setModels(data);
      })
      .catch(() => setModels([]));
    return () => {
      abandoned = true;
    };
  }, [state?.uid]);
  useEffect(() => {
    if (invoiceId) {
      setShowed((old) => {
        if (!old) {
          setTimeout(() => {
            $(`#bntFactureComptabiliteModal${invoiceId}`)?.click();
          }, 1200);
        }
        return true;
      });
    }
  }, [invoiceId, state?.uid]);

  useEffect(() => {
    if (state?.uid) {
      setShowed(false);
    } else {
      navigate("/comptabilite/utilisateurs");
    }
  }, [state?.uid]);

  if (!state) return null;

  return (
    <div className="dashboard-admin-component">
      <div className="container-dashboard-page">
        <div className="admin-page-title-header-container flex-sb align-items-center">
          <div className="fast-facture-dash-locataire-requetes-header">
            <h4
              className="fast-facture-dash-header-titre linkable"
              onClick={() => navigate(-1)}
            >
              Clients &gt;
              <span style={{ fontSize: 16, fontWeight: 400 }}>
                {state?.prenom} {state?.nom}
              </span>
            </h4>
          </div>
        </div>
        <div className="col-left-dashboard col-left-dashboard-responsive mb-3">
          <div className="bg-white p-3">
            <div className="row mb-4">
              <div className="col-md-12">
                <div className="d-flex flex-column align-items-center py-4 mb-4 fast-facture-user-avatar-container">
                  <div className="profile-avatar-container">
                    <img
                      src={state?.avatar || avatar}
                      alt="user avatar"
                      className="fast-facture-dash-locataire-param-img-avatar"
                    />
                  </div>
                  <div className="fast-facture-dash-param-title pt-2">
                    {state?.prenom} {state?.nom}
                  </div>
                  <p className="text-entreprise-user-comptabilite">
                    {state?.entreprise}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-5">
              {isLoading ? (
                <CardSkeleton />
              ) : (
                <>
                  <div className="col-lg-3 col-md-12 mb-3 dis-flex px-md-2">
                    <div className="item-stat-dashboad-view">
                      <div className="content-stat-dashboard-view">
                        <div className="content-text-item-stat-dashboad-view ms-3">
                          <div className="content-item-stat-dashboad-view mt-2">
                            <p className="titre-item-stat-dashboad-view mb-1">
                              Total factures dépenses
                            </p>
                          </div>
                          <div className="icon-item-stat-dashboad-view">
                            <p className="chiffre-item-stat-dashboad-view mb-1">
                              {" "}
                              {formatNumber(dashboard.total_facture_depenses)}
                            </p>
                          </div>
                        </div>
                        <div className="content-item-icon-stat-dashboard-view">
                          <img
                            src={Factures}
                            alt="icon"
                            className="icon-item-stat-dashboad-view"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 mb-3 dis-flex px-md-2">
                    <div className="item-stat-dashboad-view">
                      <div className="content-stat-dashboard-view">
                        <div className="content-text-item-stat-dashboad-view ms-3">
                          <div className="content-item-stat-dashboad-view mt-2">
                            <p className="titre-item-stat-dashboad-view mb-1">
                              Total TVA récupérable{" "}
                            </p>
                          </div>
                          <div className="icon-item-stat-dashboad-view">
                            <p className="chiffre-item-stat-dashboad-view mb-1">
                              {formatNumber(dashboard?.total_tve_recuperable)}
                            </p>
                          </div>
                        </div>
                        <div className="content-item-icon-stat-dashboard-view">
                          <img
                            src={TvaCollecte}
                            alt="icon"
                            className="icon-item-stat-dashboad-view"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 mb-3 dis-flex px-md-2">
                    <div className="item-stat-dashboad-view">
                      <div className="content-stat-dashboard-view">
                        <div className="content-text-item-stat-dashboad-view ms-3">
                          <div className="content-item-stat-dashboad-view mt-2">
                            <p className="titre-item-stat-dashboad-view mb-1">
                              Total factures émises
                            </p>
                          </div>
                          <div className="icon-item-stat-dashboad-view">
                            <p className="chiffre-item-stat-dashboad-view mb-1">
                              {formatNumber(dashboard?.total_facture_emises)}
                            </p>
                          </div>
                        </div>
                        <div className="content-item-icon-stat-dashboard-view">
                          <img
                            src={Users}
                            alt="icon"
                            className="icon-item-stat-dashboad-view"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 mb-3 dis-flex px-md-2">
                    <div className="item-stat-dashboad-view">
                      <div className="content-stat-dashboard-view">
                        <div className="content-text-item-stat-dashboad-view ms-3">
                          <div className="content-item-stat-dashboad-view mt-2">
                            <p className="titre-item-stat-dashboad-view mb-1">
                              Total TVA Collectée
                            </p>
                          </div>
                          <div className="icon-item-stat-dashboad-view">
                            <p className="chiffre-item-stat-dashboad-view mb-1">
                              {formatNumber(dashboard?.total_tva_emises)}
                            </p>
                          </div>
                        </div>
                        <div className="content-item-icon-stat-dashboard-view">
                          <img
                            src={TvaEmise}
                            alt="icon"
                            className="icon-item-stat-dashboad-view"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row">
              <CircleGraph userId={state.uid as string} invoices={invoices} />
            </div>
            <ul className="tabs-list px-0 mt-5">
              {tabs?.map((tab, i) => (
                <li
                  className={`tab-item ${active === i ? "active" : ""}`}
                  key={i}
                  onClick={() => handleActiveTab(i)}
                  role="button"
                >
                  {tab}
                </li>
              ))}
            </ul>
            <div className="tabs-content">
              {active === 0 && (
                <>
                  <div className="flex-sb align-items-center mb-4">
                    <div className="tab-dash-admin-filter-container"></div>
                    <ExcelExport
                      getFileData={() => getExportData(depenses, categories)}
                      fileName={`Factures_depenses_${new Date().getTime()}`}
                    />
                  </div>
                  <ListeFactureComtabiliteTable
                    invoices={depenses}
                    isLoading={isLoading}
                    reload={() => getInvoices()}
                    userId={state.uid as string}
                  />
                </>
              )}
              {active === 1 && (
                <>
                  <div className="flex-sb align-items-center mb-4">
                    <div className="tab-dash-admin-filter-container"></div>
                    <ExcelExport
                      getFileData={() => getExportDataFacture(factures)}
                      fileName={`Factures_emises_${new Date().getTime()}`}
                    />
                  </div>
                  <ListeFactureEmiseComtabiliteTable
                    invoices={factures}
                    isLoading={isLoading}
                    reload={() => getInvoices()}
                    userId={state.uid as string}
                    models={models}
                  />
                </>
              )}
              {active === 2 && (
                <>
                  <div className="flex-sb align-items-center mb-4">
                    <div className="tab-dash-admin-filter-container"></div>
                    <ExcelExport
                      getFileData={() =>
                        getExportData(emisesScannees, categories)
                      }
                      fileName={`Factures_emises_scannees_${new Date().getTime()}`}
                    />
                  </div>
                  <ListeFactureComtabiliteTable
                    invoices={emisesScannees}
                    isLoading={isLoading}
                    reload={() => getInvoices()}
                    userId={state.uid as string}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const listFilters = [
  {
    label: "Semaine",
    value: "week",
  },
  {
    label: "Mois",
    value: "month",
  },
  {
    label: "Année",
    value: "year",
  },
];

type GraphData = { cat: Categorie; count: number };
type GraphFilter = "week" | "month" | "year";
function CircleGraph({
  invoices,
  userId,
}: {
  invoices: InvoiceData[];
  userId: string;
}) {
  const [filter, setFilter] = useState<GraphFilter>("week");
  const categories = useUserCategories(userId);
  const [data, setData] = useState<GraphData[]>([]);

  useEffect(() => {
    const start = moment().startOf(filter);
    const end = moment().endOf(filter);

    const filtred = invoices.filter((i) => {
      const date = getDateFromString(i.date, i.created_at);
      return start <= date && end >= date;
    });
    const noCat = filtred.filter((f) => !f.categorie).length;
    const dt = categories.map((c) => {
      const count = filtred.filter((c2) => c2.categorie === c.id).length;
      return {
        cat: c,
        count: count,
      };
    });

    if (noCat > 0) {
      dt.push({
        cat: { color: "#000", id: "1", name: "Non catégorisé" },
        count: noCat,
      });
    }
    setData(dt.sort((a, b) => b.count - a.count));
  }, [categories, filter, invoices]);

  return (
    <div className="circle-graph-container mt-2 mb-2 px-3 py-3">
      <div className="d-flex flex-column align-items-center flex-sm-row justify-content-between">
        <h3 className="graph-title">
          Reporting des factures par rapport aux categories{" "}
        </h3>
        <ul className="list-filters d-flex p-0">
          {listFilters.map((item, i) => (
            <li
              key={item.value}
              role="button"
              className={`filter-item ${filter === item.value ? "active" : ""}`}
              onClick={() => setFilter(item?.value as GraphFilter)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
      <div className="pt-3">
        <DonutChart data={data} />
      </div>
    </div>
  );
}

export default DetailUserComptabilite;
